import React, { Suspense } from "react";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import { history } from "./store";
import { boot, paths } from "./actions/actionCreators";
import { ConnectedRouter } from "connected-react-router";
import { ThemeProvider } from "@material-ui/core/styles";
import { StylesProvider, jssPreset } from "@material-ui/core/styles";
import rtl from "jss-rtl";
import { create } from "jss";
import PreInvoice from "./new-ui/components/PreInvoice/PreInvoice";
import "./font.css";
import OrderFull from "./new-ui/components/Order/OrderPage";
import Tracker from "./new-ui/components/Tracker";
import Comment from "./new-ui/components/Comment";
import Authentication from "./new-ui/components/Authentication";
import MoreService from "./components/pages/MoreService";
import InvoiceListPage from "./components/pages/InvoiceListPage";
import RepresentativeInvoice from "./components/pages/RepresentativeInvoice";
import AuthRoute from "./components/AuthRoute";
import AfterSubmit from "./components/pages/AfterSubmit";
import NewHeader from "./new-ui/components/Header/Header";
import NowrouzGameLeaderboard from "./new-ui/components/NowrouzGame/Leaderboard";
import NowrouzReferral from "./new-ui/components/NowrouzGame/NowrouzReferral";
import NowrouzGameRules from "./new-ui/components/NowrouzGame/rules";
import NowrouzGamePrizes from "./new-ui/components/NowrouzGame/Prizes";
import FirstPage from "./new-ui/components/FirstPage";
import UpdateOrderPage from "./new-ui/components/Order/UpdateOrderPage";
import Profile from "./new-ui/components/Profile";
import theme from "./theme";
import PaymnetPage from "./new-ui/components/PaymentPage/PaymentPage";

// Metrix
import Metrix from "./metrix/metrix";
import Location from "./new-ui/components/Location";
import NewLocation from "./components/NewLocation";

/**
 * Configure JSS
 * @type {Jss}
 */
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

class App extends React.Component {
  constructor(props) {
    super(props);
    boot();

    // Metrix
    // this.metrix = Metrix.initialize({
    // 	appId: 'mupcqibfenwcrcu',
    // })
  }

  render() {
    return (
      <StylesProvider jss={jss}>
        <ThemeProvider theme={theme}>
          <ConnectedRouter history={history}>
            {/* <div
							className='bg-pattern'
							style={{
								backgroundImage: `url(${process.env.PUBLIC_URL}/orders/images/pattern.png)`,
								backgroundColor: '#FFF',
							}}> */}
            <Suspense fallback={<div></div>}>
              <Authentication />
              <NewHeader />
              <Switch>
                <Route path={paths.gamePrizes}>
                  <NowrouzGamePrizes />
                </Route>

                <Route path={paths.gameRules}>
                  <NowrouzGameRules />
                </Route>

                <Route path={paths.gameLeaderboard}>
                  <NowrouzGameLeaderboard />
                </Route>

                <Route path={paths.midPayment}>
                  <PaymnetPage />
                </Route>
                {/* <AuthRoute path={paths.game}>
                                        <NowrouzReferral/>
                                    </AuthRoute> */}

                <AuthRoute exact path={paths.order_history}>
                  <InvoiceListPage />
                </AuthRoute>

                <AuthRoute exact path={paths.comment}>
                  <Comment />
                </AuthRoute>

                <AuthRoute exact path={paths.trackingIntercity}>
                  <Tracker />
                </AuthRoute>

                <AuthRoute exact path={paths.tracking}>
                  <Tracker />
                </AuthRoute>

                <AuthRoute exact path={paths.nissanAfterSubmit}>
                  <Tracker />
                </AuthRoute>

                <AuthRoute exact path={paths.truckAfterSubmit}>
                  <Tracker />
                </AuthRoute>

                <AuthRoute exact path={paths.smallTruckAfterSubmit}>
                  <Tracker />
                </AuthRoute>

                <AuthRoute exact path={paths.representative_invoice}>
                  <RepresentativeInvoice />
                </AuthRoute>

                <AuthRoute exact path={paths.profile}>
                  <Profile />
                </AuthRoute>

                <AuthRoute path={paths.order_submitted}>
                  <AfterSubmit />
                </AuthRoute>

                <AuthRoute path={paths.worker_services}>
                  <MoreService />
                </AuthRoute>

                <AuthRoute path={paths.preInvoiceIntercity}>
                  <PreInvoice />
                </AuthRoute>

                <AuthRoute path={paths.invoice}>
                  <PreInvoice />
                </AuthRoute>

                <AuthRoute path={paths.update_order}>
                  <UpdateOrderPage />
                </AuthRoute>

                <AuthRoute exact path={paths.order}>
                  <OrderFull />
                </AuthRoute>

                {/* <AuthRoute path={paths.selectDestination}>
										<SimpleMap />
									</AuthRoute>
									<AuthRoute path={paths.map}>
										<SimpleMap />
									</AuthRoute> */}
                {/* Test */}
                <AuthRoute path={paths.map}>
                  <Location />
                </AuthRoute>
                <AuthRoute path={paths.selectDestination}>
                  <Location />
                </AuthRoute>
                {/* Test */}

                <AuthRoute path={paths.service}>
                  <FirstPage />
                </AuthRoute>

                <AuthRoute path={paths.referral}>
                  <FirstPage />
                </AuthRoute>
              </Switch>
            </Suspense>
            {/* </div> */}
          </ConnectedRouter>
        </ThemeProvider>
      </StylesProvider>
    );
  }
}
export default App;
